"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableTypography = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var Button_1 = require("../../atoms/Button/Button");
var Typography_1 = require("../../atoms/Typography/Typography");
var ExpandableTypography_logic_1 = require("./ExpandableTypography.logic");
var ExpandableTypography_static_1 = require("./ExpandableTypography.static");
/**
 * ExpandableTypography molecule
 *
 * {@link https://stories.data.bmw.cloud/?path=/docs/molecules-expandabletypography--bound-story Docs}
 * {@link https://github.com/bmw-cdh/cdh-data-portal-theme/tree/main/components/molecules/ExpandableTypography Source}
 */
var ExpandableTypography = function (_a) {
    var _b = _a.buttonVariant, buttonVariant = _b === void 0 ? 'text' : _b, numberOfLines = _a.numberOfLines, _c = _a.showMore, showMore = _c === void 0 ? true : _c, children = _a.children, rest = __rest(_a, ["buttonVariant", "numberOfLines", "showMore", "children"]);
    var _d = (0, ExpandableTypography_logic_1.useExpandableTypography)({
        numberOfLines: numberOfLines,
        showMore: showMore,
        children: children,
    }), calculatedNumberOfLines = _d.calculatedNumberOfLines, isExpanded = _d.isExpanded, shouldRenderButton = _d.shouldRenderButton, toggleIsExpanded = _d.toggleIsExpanded, ref = _d.ref;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Typography_1.Typography, __assign({ numberOfLines: calculatedNumberOfLines }, rest, { ref: ref, breakWord: true }, { children: children })), shouldRenderButton && ((0, jsx_runtime_1.jsx)(Button_1.Button, { variant: buttonVariant, title: isExpanded ? ExpandableTypography_static_1.localText.showLess : ExpandableTypography_static_1.localText.showAll, onClick: toggleIsExpanded }))] }));
};
exports.ExpandableTypography = ExpandableTypography;
